import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "./supabaseClient";
import AdminDashboard from "./components/admin/AdminDashboard";
import "./AdminPage.css";

export default function AdminPage({ currentUser }) {
  const [userLevel, setUserLevel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchUserLevel = async () => {
      setLoading(true);
      setUserLevel(null);
      setLoadError("");

      if (!currentUser?.user_level_id) {
        if (!cancelled) setLoading(false);
        return;
      }

      const { data, error } = await supabase
        .from("user_levels")
        .select("*")
        .eq("id", currentUser.user_level_id)
        .single();

      if (cancelled) return;

      if (error) {
        console.error("Unable to load admin user level:", error);
        setLoadError(error.message || "Unable to verify admin access.");
      } else {
        setUserLevel(data);
      }

      setLoading(false);
    };

    fetchUserLevel();

    return () => {
      cancelled = true;
    };
  }, [currentUser?.id, currentUser?.user_level_id]);

  if (loading) {
    return (
      <div className="admin-loading-screen">
        <div className="admin-loader-card">
          <div className="admin-loader-spinner" />
          <h2>Loading Hobbli Admin...</h2>
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="admin-loading-screen">
        <div className="admin-loader-card admin-loader-card-error">
          <h2>Admin access check failed</h2>
          <p>{loadError}</p>
        </div>
      </div>
    );
  }

  if (!userLevel || Number(userLevel.level) < 50 && Number(userLevel.level) !== 25) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="admin-page">
      <AdminDashboard currentUser={currentUser} contributorOnly={Number(userLevel.level) === 25} />
    </div>
  );
}
